import React from 'react'


function Footer() {
    return (
        <div className="footer">

            <div className="container">

                <div className="footer-container">

                    <div className="footer-list-block">

                        <h2 className="footer-title">Community</h2>

                        <ul className="w-list-unstyled">

                            <li><a href="https://elyxrsps.com/forums/register" className="footer-link">Create an account</a></li>

                            <li><a href="https://discord.gg/E9cTgxKuSG" target="_blank" rel="noreferrer" className="footer-link">Discord Server</a></li>

                            <li><a href="http://elyxrsps.com/forums/login" className="footer-link" >Login to Forums</a></li>

                            <li><a href="https://elyxrsps.com/forums/forum/6-introductions-and-farewells/" className="footer-link" >Make an introduction</a></li>

                        </ul>

                    </div>

                    <div className="footer-list-block">

                        <h2 className="footer-title">Game</h2>

                        <ul className="w-list-unstyled">

                            <li><a href="https://elyxrsps.com/forums/forum/2-news-and-announcements/" className="footer-link" >Latest Updates</a></li>

                            <li><a href="https://elyxrsps.com/forums/forum/2-news-and-announcements/" className="footer-link">Announcements</a></li>

                            <li><a href="https://elyxrsps.com/vote/" className="footer-link">Vote for Elyx</a></li>

                            <li><a href="https://elyxrsps.com/store/" className="footer-link">Store</a></li>

                        </ul>

                    </div><a href="https://elyxrsps.com/" id="w-node-7e53a3672a9d-a3672a7a" className="footer-logo w-nav-brand"><img style={{ maxWidth: '100%' }} src="https://elyxrsps.com/resources/images/Logo.png" alt="Elyx Logo Design" /></a>

                    <div className="footer-list-block">

                        <h2 className="footer-title">Forums</h2>

                        <ul className="w-list-unstyled">

                            <li><a href="https://elyxrsps.com/forums/" className="footer-link">Forums</a></li>

                            <li><a href="https://elyxrsps.com/forums/forum/8-guides/" className="footer-link">Game Guides</a></li>

                            <li><a href="https://elyxrsps.com/forums/forum/8-guides/" className="footer-link">Skilling Guides</a></li>

                            <li><a href="http://elyxrsps.com/forums/register" className="footer-link">Register Account</a></li>

                        </ul>

                    </div>

                    <div className="footer-list-block">

                        <h2 className="footer-title">Support</h2>

                        <ul className="w-list-unstyled">

                            <li><a href="https://elyxrsps.com/forums/forum/24-general-support/" className="footer-link">Client Support</a></li>

                            <li><a href="https://elyxrsps.com/forums/forum/24-general-support/" className="footer-link" >In-game Support</a></li>

                            <li><a href="https://discord.gg/E9cTgxKuSG" target="_blank" rel="noreferrer" className="footer-link" >Discord Support</a></li>

                            <li><a href="https://elyxrsps.com/forums/forum/24-general-support/" className="footer-link">Store Support</a></li>

                        </ul>

                    </div>

                </div>

            </div>

            <div className="bottom-bar">

                <div className="container bottom-bar-content">

                    <div className="bottom-link">© 2023 Elyx RSPS | All Rights Reserved</div>

                    <div className="footer-right-block"><a href="http://google.com" className="bottom-text">Privacy Policy</a><a href="http://google.com" className="bottom-text">Terms&nbsp;&amp; Conditions</a></div>

                </div>

            </div>

        </div>
    )
}

export default Footer